"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NavSection;
var _react = _interopRequireDefault(require("react"));
require("./styles.scss");
function NavSection(props) {
  const {
    title,
    separator = true
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "nav-section"
  }, separator && /*#__PURE__*/_react.default.createElement("div", {
    className: "divider"
  }), title && /*#__PURE__*/_react.default.createElement("span", {
    className: "nav-section--title ".concat(separator ? '' : 'no-separator')
  }, title));
}